<div class="body ui container" fxLayout="column">

        <div fxLayout="row" fxLayoutAlign='space-between center' class="top">

		 <div fxLayoutAlign='start center' fxLayout='row' fxLayoutGap='20px' (click)="goBack()" class="link">
                <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div>
                <div class='equipment-id'>
					<!-- Title -->
                    <h2 class="ui primary header">User Management</h2>
                </div>
            </div>



           <div fxLayout='row' fxLayoutGap='15px'>
            <button (click)="deleteUser()" class="ui small icon basic primary  button" suiPopup [popupInverted]="true" popupPlacement="bottom" popupText="remove project">
                <i class="trash alternate icon"></i>
                </button>


            <button (click)="newUser()" class="ui small button primary" >New User</button>
            </div>
        </div>
        <div class="ui divider" appMargin marginY="3"></div>

        <div class="ui segment" style="border-radius: 4px;" appMargin marginT="0">
            <app-search-filter
					[filter]="filter"
					(onSearch)="searchRecords($event)"
					(onDisplayRows)="displayRecords($event)"
					(onSort)="sortRecords($event)"
            ></app-search-filter>
        </div>


    <div class="ui vertical basic segment" [ngClass]="{'loading':pending}">
<div fxLayout="row" tamsyMargin class="ui segment" marginB="3" fxLayoutGap="10px" fxLayoutAlign="start stretch" id="dark">
	<div fxFlex="5%">
		   <sui-checkbox >
            </sui-checkbox>
	</div>
		<div fxFlex="15%">NAME</div>
        <div fxFlex="25%">EMAIL</div>
        <div fxFlex>PHONE NUMBER</div>
        <div fxFlex>DEPARTMENT</div>
        <div fxFlex>STATUS</div>
		<div fxFlex></div>
</div>
	  <app-user-row
		[user]="s"
		*ngFor="let s of users"
		(onDelete)="onDelete($event)"></app-user-row>



    <div class="ui vertical basic segment">
        <div class="ui two column grid">
            <div class="column middle aligned">
			    <div class="ui icon small button">
                <i class="database icon"></i>
                </div>
                <a class="ui basic label">{{totalItems}} Record(s)</a>
            </div>
            <div class="column right aligned pagination menu" style='margin-left: auto;'>
                <sui-pagination
                class="small"
                 [collectionSize]="totalItems"
                 [pageSize]="rows"
                 [maxSize]="maxSize"
                  [hasEllipses]="false"
                  [page]="currentPage"
                  (pageChange)="nextPage($event)">
                </sui-pagination>
            </div>
        </div>
    </div>

</div>
</div>

